import { Injectable } from '@angular/core';
import { Address } from '../../models';
import { ApiService } from '@meddatacore/common';

@Injectable({
    providedIn: 'root',
})
export class AddressService extends ApiService {

    get(id: string) {
        return this.http.get(`${this.persionBaseURL}/api/address/${id}`);
    }
    
    getPersonAddress(personId: string) {
        return this.http.get(`${this.persionBaseURL}/api/address/persons/${personId}/address`);
    }

    create(address: Address) {
        return this.http.post(`${this.persionBaseURL}/api/address`, address);
    }

    update(address: Address) {
        return this.http.put(`${this.persionBaseURL}/api/address`, address);
    }
}
